const initialState = { arr: [{id_user: '', pseudo: '', id_avatar: ''}] }

export default function userDetailReducer(state = initialState, action) {
  switch (action.type) {
    case 'user/userDetail': {
      // Can return just the new todos array - no extra object around it
      return {
        ...state,
        arr: action.payload,
      }
    }
    default:
      return state
  }
}